export default "__VITE_ASSET__D6WI59at__"